import { PlatformUserRole, useCurrentPlatformUserQuery } from '@dashboard/generated/wp/authentication';
import useCurrentPlatformId from '@dashboard/hooks/route/useCurrentPlatformId';

export function useCurrentPlatformUser() {
  const platformId = useCurrentPlatformId();
  return useCurrentPlatformUserQuery({ variables: { platformId } });
}

export type TPermission =
  | 'createApiKey'
  | 'createVerifiedDomain'
  | 'createVerifiedEmailAddress'
  | 'deletePlatformUser'
  | 'haltPlatformEmailMessageSending'
  | 'invitePlatformUser'
  | 'invitePlatformUser'
  | 'updatePlatformInformation'
  | 'updatePlatformSesEventTracking'
  | 'updateSubscription'
  | 'updateVerifiedEmailAddress';

export function usePermission(name: TPermission): boolean {
  const { data } = useCurrentPlatformUser();
  const role = data?.currentPlatformUser.role;

  switch (name) {
    case 'createApiKey':
    case 'createVerifiedDomain':
    case 'createVerifiedEmailAddress':
    case 'deletePlatformUser':
    case 'haltPlatformEmailMessageSending':
    case 'invitePlatformUser':
    case 'updatePlatformInformation':
    case 'updatePlatformSesEventTracking':
    case 'updateSubscription':
    case 'updateVerifiedEmailAddress':
      return role === PlatformUserRole.Admin || role === PlatformUserRole.Owner;
  }
}
